module.exports = __webpack_public_path__ + "static/media/ChocoChip Cookies 100g.294523b2.jpg";